<div>
    <div class="text-danger" v-if="(products === null || products.length === 0) && (depotId !== null && depotId > 0)">
        No products available for selected depot
    </div>
    <div class="input-group pb-4">
        <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
        <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
        </div>
    </div>
    <div class="pb-4 w-100">
        <button class="btn btn-primary float-right" @click="onFilterSearchClick">Search</button>
    </div>
    <div class="table-responsive pt-4">
        <table class="table table-hover mb-0">
            <thead>
            <tr>
                <th>
                    Select
                </th>
                <th>Product</th>
                <th>Price</th>
                <th>Discounted Amount</th>
                <th>Price After Discount</th>
                <th>Quantity</th>
                <th>Total</th>
                <th>Total After Discount</th>
                
            </tr>
            </thead>
            <tbody>
            <tr v-for="(product, index) in products" :key="index">
                <td>
                    <input type="checkbox" v-model="product.selected" @change="onProductSelect(product)">
                </td>
                <td>{{product.product}}</td>
                <td>{{product.priceAsString}}</td>
                <td>{{product.discountAmountAsString}}</td>
                <td>{{product.priceAfterDiscountAsString}}</td>
                <td>
                    <div v-if="product.loading">
                        Checking For Discounts...
                    </div>
                    <div class="text-danger">
                        {{product.errorMessage}}
                    </div>
                    <input v-show="!product.loading" type="number" v-model="product.quantity" @input="onQuantityInput(product)" @blur="onProductSelect(product)"/>
                </td>
                <td>{{product.totalAsString}}</td>
                <td>{{product.totalAfterDiscountAsString}}</td>
            </tr>
            </tbody>
        </table>
        <div class="float-right">
            Grand Total {{orderTotalAsString}}
        </div>
    </div>
    
</div>